import React from "react";
import {
  FaFacebook,
  FaGithub,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";
import { FaUpwork } from "react-icons/fa6";
import { Link } from "react-router-dom";
import DemoCTA from "./DemoCTA";
import { MdOutlineEmail } from "react-icons/md";

const Footer = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = "+923415352981";
    window.open(`https://wa.me/${phoneNumber}`, "_blank");
  };

  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 210">
        <path
          fill="#4B5563"
          fillOpacity="1"
          d="M0,128L60,112C120,96,240,64,360,74.7C480,85,600,139,720,170.7C840,203,960,213,1080,197.3C1200,181,1320,139,1380,117.3L1440,96L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
        ></path>
      </svg>
      <footer className="relative bg-gray-600 text-white z-[1000]">
        <DemoCTA />
        <div className=" container mx-auto px-8 pb-8 md:px-16 lg:px-24">
          <div className="flex flex-col md:flex-row md:space-x-12 items-center mb-4">
            <Link to="/" className="flex-1 my-4">
              <img
                src={require("../assets/images/logo-nobg.png")}
                alt="logo"
                className="w-40"
              />
            </Link>
            <div className="md:w-[25%] md:mb-0 mb-3">
              <div>
                <h2>
                  Subscribe Our Newsletter to Stay Updated about
                  AS-Tech Programs.
                </h2>
                {/* <h2>Testimonials</h2> */}
              </div>
              {/* <div>
                                <h2>Terms of services</h2>
                                <h2>Privacy Policy</h2>
                                <h2>Login</h2>
                            </div> */}
            </div>
            <div className="flex-1 w-full">
              <form className="flex items-center justify-center">
                <input
                  type="email"
                  placeholder="Your email"
                  className="relative w-[60%] h-12 p-2 rounded-l-full bg-gray-800 border-t-2 border-l-2 border-b-2 border-white 
                focus:outline-none focus:border-orange-500"
                ></input>
                <div className="border-t-2 border-r-2 h-12 border-b-2 rounded-r-full p-[0.25rem] bg-gray-800">
                  <button
                    type="submit"
                    className="bg-gradient-to-r from-orange-500 to-red-500 text-white py-2 px-3 rounded-full font-semibold shadow-lg"
                  >
                    <MdOutlineEmail size={20} />
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div
            className="border-t border-gray-600 pt-4 flex flex-col md:flex-row 
          justify-between items-center"
          >
            <p className="">
              <span className="text-lg">©</span> {new Date().getFullYear()} AS
              Tech. All rights reserved.
            </p>
            <div className="flex space-x-4 my-4 md:my-0">
              {/* <Link to="#" className="text-gray-400 hover:text-white">
              <FaFacebook />
            </Link>
            <Link to="#" className="text-gray-400 hover:text-white">
              <FaTwitter />
            </Link> */}
              <Link
                to="https://www.instagram.com/astechcommunity/"
                target="_blank"
                className="hover:text-red-500 text-white"
              >
                <FaInstagram size={30} />
              </Link>
              <Link
                to="https://www.facebook.com/astechcommunity/"
                target="_blank"
                className="hover:text-logo text-white"
              >
                <FaFacebook size={30} />
              </Link>
              <Link
                to="https://www.linkedin.com/company/astechcommunity"
                target="_blank"
                className="hover:text-blue-500 text-white"
              >
                <FaLinkedin size={30} />
              </Link>
              <Link
                to=" https://www.youtube.com/AnumShaheen"
                target="_blank"
                className="hover:text-red-600 text-white"
              >
                <FaYoutube size={30} />
              </Link>
              <Link
                to="https://chat.whatsapp.com/Ly9eCbbsdtkGeL9pOoQKg1"
                target="_blank"
                className="hover:text-green-500 text-white"
              >
                <FaWhatsapp size={30} />
              </Link>
            </div>
            <div className="flex space-x-4">
              <Link to="about-us" className="text-white">
                About
              </Link>
              <Link to="/contact" className="text-white">
                Contact
              </Link>
              <Link
                to="https://theastc.com"
                className="text-white"
              >
                More About Us
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
